import {gsap} from "gsap";
import {Presentation, PresentationState} from "../../../../core/gameflow/controller/Presentation";
import {GameData} from "../../../server/data/GameData";
import {ReelEngineManager} from "../../../../core/reel/ReelEngineManager";
import {GameSetting} from "../../../../core/setting/GameSetting";
import {ArrayHelper} from "../../../../core/utils/ArrayHelper";
import {Helper} from "../../../../core/utils/Helper";
import {ReelEngineController} from "../../../../core/reel/ReelEngineController";
import {PunkRocker} from "../../../PunkRocker";
import {SoundManager} from "../../../sound/SoundManager";
import {SoundConfig} from "../../../sound/SoundConfig";
import {PREngineManager} from '../../../punkEngine/PREngineManager';
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {ReelState} from "../../../../core/reel/ReelEngineView";
import {PRGameMode} from "../../../server/PRGameMode";

export class StopPresentation extends Presentation {

    protected gameData: GameData;
    protected animationTl: gsap.core.Timeline;
    protected scatterPos: number[];
    protected countScatter: number = 0;

    protected possibleWin: boolean[][] = [];

    protected isFSSUPER: boolean = false;

    protected get basicStopDelay(): number[] {

        let delay: number[] = this.possibleWin.length > 2 ? [0, 0.3, 0.7, 0.9, 1.1, 1.3] : [0, 0.3, 0.6, 0.8, 1, 1.2];

        if (ReelEngineManager.isQuickStop || GameSetting.isFastSpin) {
            delay = [0, 0, 0, 0, 0, 0];//  [0, 0.01, 0.02, 0.03, 0.04, 0.05];// GameSetting.isFastSpin ? delay.map(v => v*0.25) : [0, 0.01, 0.02, 0.03, 0.04]
        }

        return delay;
    }

    setGamedData(data: GameData): void {
        this.countScatter = 0;
        this.gameData = data;
        this.isFSSUPER = (this.gameData.mode === PRGameMode.FREESPIN_LEVEL_TWO || this.gameData.mode === PRGameMode.FREESPIN_LEVEL_THREE);
        this.scatterPos = data.Reel.scatterPositions;

        if (this.possibleWin.length > 2) {
            ArrayHelper.eachForEach(this.possibleWin, (reel, row) => {
                if (this.possibleWin[reel][row] && !data.Win.allBetWayWinData.reelWinPositions[reel][row]) {
                    this.possibleWin[reel][row] = false;
                }
            });

            if (!this.possibleWin[0].find(() => true) || !this.possibleWin[1].find(() => true))
                this.possibleWin = [];
        }

        ReelEngineManager.parseData(data.Reel);
    }

    preStart(): void {
        this.animationTl = Helper.setTimeline(this.animationTl, new gsap.core.Timeline());
    }

    playBounceSound(reelID: number): void {
        SoundManager.playReelStop(reelID);

        if (ReelEngineManager.lastStopOrder === reelID) {
            SoundManager.stopSoundEffect(SoundConfig.REELS_SPINNING);
        }
    }

    createPresentation(enableSkip: Function) {
        if (this.readyToDefineStop()) {
            this.createStopSpins();
            ReelEngineManager.stopReels(this.defineDelays());
        }
    }

    skip(): void {
        this.PresentationState.set(PresentationState.ACTIVATED);
        ReelEngineManager.isQuickStop = true;
        super.skip();
    }

    isFinished(): boolean {
        const notFinished: boolean = !(ReelEngineManager.getFirstStoppingReel() >= 0 || ReelEngineManager.findReelWithState(ReelState.STEP) >= 0)
        if (!notFinished) return notFinished;

        if (this.animationTl.isActive()) return false;

        return true;
    }

    done() {
        SoundManager.stopSoundEffect(SoundConfig.REELS_SPINNING);
        PunkRocker.reelEngineManager.applyMask(false);
        Logger.log("Stop Done")
    }

    // Add animation offset that couldn't be calculated.
    protected addAnimOffset(): void {
        if (this.animationTl.isActive()) {
            this.timeline.to(this, {duration: this.animationTl.duration() - this.animationTl.time()}, 0);
        }
    }

    // Add Start Offset.
    protected addStartReelOffset(): boolean {
        const remaining: number = ReelEngineManager.remainingStartEngineOffset();
        this.timeline.to(this, {duration: remaining}, 0);
        return !!remaining;
    }

    // Add animation offset that couldn't be calculated.
    protected addRemainingReelStop(): void {
        this.timeline.to(this, {duration: ReelEngineManager.lastSpinningTime || ReelEngineManager.remainingAnimatedReelTime}, 0);
    }

    protected createStopSpins(): void {
        ReelEngineManager.RAll((rc: ReelEngineController) => rc.createStop({
            stops: () => this.onStops(rc),
            bounce: () => this.onBounce(rc),
            stopped: () => this.onStopped(rc)
        }));
    }

    protected readyToDefineStop(): boolean {

        if (!this.PresentationState.isActive) {
            this.addAnimOffset();
            this.addRemainingReelStop();
            return false;
        }

        if (this.addStartReelOffset()) return false;

        // this.PresentationState.setInactive();

        return true;
    }

    protected defineDelays(): number[] {
        return this.basicStopDelay;
    }

    protected onStops(rc: ReelEngineController): void {
        rc.setGraphAlpha(0, rc.stopDuration);
    }

    // scatterLvlState(lvl: number) {
    //     return [ScatterSymState.LEVEL_1, ScatterSymState.LEVEL_2, ScatterSymState.LEVEL_3, ScatterSymState.LEVEL_4, ScatterSymState.LEVEL_5][lvl]
    // }

    protected onBounce(rc: ReelEngineController): void {
    }

    protected onStopped(rc: ReelEngineController): void {
    }

    protected possibleWinNonWins(reelID: number): void {
        if (ReelEngineManager.isQuickStop || GameSetting.isFastSpin) {
            if (ReelEngineManager.isQuickStop && reelID > 1) {
                for (let rec: number = 0; rec <= reelID; rec++) {
                    PREngineManager.getReel(rec).AllWindowSymbols.forEach((s, row) => {
                        if (s.isNormalSym) s.markNonWin(false, 0, 0.1);
                    })
                }
            }
            return;
        }
        if (reelID > 1 && this.possibleWin.length > 2) {

            const alpha = 0.55;
            const durr = 0.6;

            if (reelID == 2) {
                for (let rec: number = 0; rec <= reelID; rec++) {
                    PREngineManager.getReel(rec).AllWindowSymbols.forEach((s, row) => {
                        s.markNonWin(!this.possibleWin[rec][s.posID[0]], alpha, durr);
                    })
                }
            } else if (this.possibleWin[reelID] && this.possibleWin[reelID].length) {
                PREngineManager.getReel(reelID).AllWindowSymbols.forEach((s, row) => {
                    if (!this.possibleWin[reelID][s.posID[0]]) s.markNonWin(true, alpha, durr);
                })
            } else {
                PREngineManager.getReel(reelID).AllWindowSymbols.forEach((s, row) => {
                    if (s.isNormalSym) s.markNonWin(true, alpha, durr);
                })
            }
        }
    }
}